module.exports = __webpack_public_path__ + "webfonts/lg.eot";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/fonts/lg.eot?n1z373
// module id = 518
// module chunks = 64 65